import { css } from 'styled-components';
import { Nullable } from '@lerna-core';

export const getMobileFilterStyles = (
  isCustomFilter?: boolean,
  isToggles?: boolean,
  background?: Nullable<string>
): ReturnType<typeof css> => {
  switch (true) {
    case isCustomFilter:
      return css`
        padding: 12px 30px 12px 12px;
        background: ${background ? `${background}` : 'transparent'};
        border-radius: 8px;
        margin: 16px 0;
      `;
    case isToggles:
      return css``;
    default:
      return css`
        padding: 16px 32px 16px 0;
      `;
  }
};
